module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-select', {
    attrs: {
      "value": _vm.computedValue,
      "options": _vm.localOptions,
      "label": _vm.label,
      "on-change": _vm.change,
      "searchable": _vm.searchable,
      "multiple": _vm.multiple,
      "placeholder": _vm.placeholder,
      "transition": _vm.transition,
      "clearSearchOnSelect": _vm.clearSearchOnSelect
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3014367c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComboBox.vue
// module id = 224
// module chunks = 1